import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                       NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *           UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 *     This program is confidential and a trade secret of Ab Initio.
 *     The receipt or possession of this program does not convey any
 *     rights to reproduce or disclose its contents, or to manufacture,
 *     use or sell anything that it may describe, in whole or in part,
 *     without the specific written consent of Ab Initio.
 */

import { Assert } from "abweb/utils/Assert";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { AlreadyHandledError } from "abweb/utils/PromiseUtils";
const LOG = LogUtils.getLogger(__filename);

/**
 * A buffer to store application startup errors before the application has initialized its UI to the point where
 * it can render them.<br>
 * When an application has replaced this error renderer with the real UI error renderer, call forwardStartupErrors
 * to render the buffered startup errors.
 */
export class ErrorContextRenderBuffer {
  constructor() {
    /** the buffer of errors */
    _defineProperty(this, "errorBuffer", new Array());
  }
  handleErrorContext(errCtx) {
    /*
     * Don't buffer up AlreadyHandledErrors.
     * When these are thrown during application initialization, they are short circuiting the application load.
     */
    if (!ClassUtils.isInstanceOf(errCtx.error, AlreadyHandledError)) {
      // just push it on to the error buffer
      this.errorBuffer.push(errCtx);
    }
  }

  /**
   * Forward the accumulated application startup errors to the real UI error renderer to display to the user,
   * and resets the buffer to empty
   * @param newErrorRenderer the new UI error renderer
   */
  forwardBufferedErrors(newErrorRenderer) {
    const bufferedErrs = [...this.errorBuffer];
    this.resetErrorBuffer();
    for (let error of bufferedErrs) {
      try {
        newErrorRenderer.handleErrorContext(error);
      } catch (err) {
        LOG.error("Swallowed error while trying to forward a buffered error for rendering." + err);
      }
    }

    // Defensive as unexpected
    Assert.developerAssertContinue(this.errorBuffer.length === 0, "More buffered errors queued up while processing buffered errors");
  }

  /** Used for testing */
  resetErrorBuffer() {
    this.errorBuffer = []; // fastest way to empty the array
  }
}
//# sourceMappingURL=ErrorContextRenderBuffer.js.map
